import React from "react";
import {InputLabel} from "@mui/material";
import PhoneInput from 'react-phone-input-2'
import "../../style/input/phoneInput.css"
import 'react-phone-input-2/lib/material.css'

export function PhoneInputAlpha(props) {
    return (
        <div className={`alpha-phoneInput ${props.containerClassName}`}>
            <InputLabel className={props.labelClassName}>{props.label}</InputLabel>
            <PhoneInput id="phone" name={props.name}
                        inputClass={`disabled:text-[#00000061] font-Roboto ${props.inputClassName}`}
                        placeholder={props.placeholder} onChange={props.onChange}
                        // value={props.value}
                        disabled={props.disabled}
                        type={'phoneNumber'}
                        country={props.country}
                        enableSearch
                        searchClass={'rounded-md'}
                        value={"+"+props.value}
                        pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                        maxLength="15"
                        required/>

        </div>
    )
}
